import Vue from 'vue'
import { websocket } from '@/services/'
import store from '@/store'
import * as socketDispatcher from '@/helpers/socketDispatcher'

const MANAGE_WEBSOCKET = 'MANAGE_WEBSOCKET'
const UNSUBSCRIBE_ACTION_CABLE = 'UNSUBSCRIBE_ACTION_CABLE'
const LOADING_ACTION_CABLE = 'LOADING_ACTION_CABLE'

const initialState = {
  loadingActionCable: false,
  socket: {
    isConnected: false,
    reconnectError: false,
    subscribeId: null,
    pendingSubscription: false,
    pendingData: {}
  }
}

const state = { ...initialState }

const mutations = {
  SOCKET_ONOPEN (state, event) {
    Vue.prototype.$socket = event.currentTarget
    state.socket.isConnected = true
    if (state.socket.pendingSubscription) {
      store.dispatch('manageActionCable', state.socket.pendingData)
    }
  },

  SOCKET_ONCLOSE (state, event) {
    state.socket.isConnected = false
  },

  SOCKET_ONERROR (state, event) {},

  SOCKET_ONMESSAGE (state, message) {
    socketDispatcher.dispatch(message)
  },

  SOCKET_RECONNECT (state, count) {},

  SOCKET_RECONNECT_ERROR (state) {
    state.socket.reconnectError = true
  },

  [MANAGE_WEBSOCKET]: function (state, param) {
    state.loadingActionCable = true
    const newId = websocket.getSubscribeId(param)

    if (!state.socket.isConnected) {
      state.socket.pendingSubscription = true
      state.socket.pendingData = param
      return
    }

    if (state.socket.subscribeId && state.socket.subscribeId !== newId) {
      const obj = JSON.stringify({
        'command': 'unsubscribe',
        'identifier': state.socket.subscribeId
      })
      Vue.prototype.$socket.send(obj)
    }

    state.socket.subscribeId = newId

    const obj = JSON.stringify({
      'command': 'subscribe',
      'identifier': newId
    })
    Vue.prototype.$socket.send(obj)
  },

  [LOADING_ACTION_CABLE]: function (state, payload) {
    state.loadingActionCable = payload
  },

  [UNSUBSCRIBE_ACTION_CABLE]: function (state, param) {
    const obj = JSON.stringify({
      'command': 'unsubscribe',
      'identifier': state.socket.subscribeId
    })

    Vue.prototype.$socket.send(obj)

    state.socket.subscribeId = null
  }
}

const actions = {
  manageActionCable: function ({ commit }, payload) {
    commit(MANAGE_WEBSOCKET, payload)
  },

  unsubscribeActionCable: function ({ commit }) {
    commit(UNSUBSCRIBE_ACTION_CABLE)
  },

  loadingCable: function ({ commit }, payload) {
    commit(LOADING_ACTION_CABLE, payload)
  }
}

export default {
  state,
  mutations,
  actions
}
